import './BlogCard.scss';
import { Link } from 'react-router-dom';

function BlogCard({ image, alt, tag, date, title, slug }) {
  return (
    <Link 
      to={`/blog/${slug}`} 
      className="blog-card" 
      aria-label={`Read blog: ${title}`}
    >
      <div className="blog-card__image-wrapper">
        <img className="blog-card__image" src={image} alt={alt || title} />
      </div>

      <div className="blog-card__content-container">
        <span className="blog-card__tag-text">{tag} | {date}</span>
        <h2 className="blog-card__header">{title}</h2>
      </div>

      <div className="blog-card__content-container-mobile">
        <span className="blog-card__tag-text--mobile">{tag} | {date}</span>
        <h2 className="blog-card__header--mobile">{title}</h2>
      </div>
    </Link>
  );
}

export default BlogCard;